// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".prose-highlight mark{background-color:transparent;color:#f6d87c}.prose-highlight a{cursor:pointer;-webkit-text-decoration:underline;text-decoration:underline;text-decoration-color:#7f838d;text-decoration-style:dashed;text-decoration-thickness:1px;text-underline-offset:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
